// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".container___jKwFr{display:inline-block;margin-right:8px}\n", "",{"version":3,"sources":["webpack://./src/routes/ManageTenants/routes/TenantGroup/components/TenantGroupRulesTable/SplitViewContent/TenantGroupOverridePaper/RemoveOverrideBtn/RemoveOverrideBtn.css"],"names":[],"mappings":"AAAA,mBACI,oBAAA,CACA,gBAAA","sourcesContent":[".container {\n    display: inline-block;\n    margin-right: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "container___jKwFr"
};
export default ___CSS_LOADER_EXPORT___;
